export const enum ArrivalDeclarationStatusTypeEnum {
    PROCESS = 'process',
    DONE = 'done',
    FILLING = 'filling',
}
